export const TOAST_DURATION = 2500;
export const DEFAULT_RETURN_POLICY =
  'We offer a hassle-free 7-day return policy. If you are not satisfied with the product, you can initiate a return or exchange request within 7 days of delivery. The product must be unused and in its original packaging.';
export const DEFAULT_SHIPPING_POLICY =
  'Orders are shipped within 24-48 hours and typically delivered within 3-5 business days. Cash on delivery is available for all pin codes.';
export const DEFAULT_PRIVACY_POLICY =
  'We secure your personal data and do not share it with third parties. Your payment information is encrypted and processed securely.';
